/**
 * 阿里上传组件
 *
 * @format
 */

import React, {
  Component
} from 'react'
import PropTypes from 'prop-types'

class Index extends Component {
  static propTypes = {
    uploaderInit: PropTypes.func.isRequired,
  }

  static defaultProps = {
    id: 'img_upload', //触发上传的节点id
    title: 'Image files',
    dirname: '',
    extensions: 'jpg,png,jpeg,gif', //限制上传类型
    max_file_size: '500mb', //最大文件大小
    uploadProgress: (up, file) => { }, //file.percent 代表进度
    fileUploaded: (up, file, info) => { }, //上传成功
    filesAdded: (up, files) => {
      return true
    }, //添加文件后
    token: {},
  }

  uploaderInit = () => {
    let _this = this
    this.g_dirname = this.props.dirname
    this.g_object_name = ''
    let _now = new Date()
    let expirationTime = new Date(_now.setDate(_now.getDate() + 1))
    let policyText = {
      expiration: expirationTime, //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
      conditions: [
        ['content-length-range', 0, 1048576000], // 设置上传文件的大小限制
      ],
    }
    this.policyBase64 = Base64.encode(JSON.stringify(policyText))
    let message = this.policyBase64
    let bytes = Crypto.HMAC(
      Crypto.SHA1,
      message,
      '2dUPMFp4dPgD3WzSJixIVabEiZKvP6', {
      asBytes: true,
    }
    )
    this.signature = Crypto.util.bytesToBase64(bytes)
    this.uploader = new plupload.Uploader({
      runtimes: 'html5,flash,silverlight,html4',
      browse_button: _this.props.id,
      //multi_selection: false,
      // container: document.getElementById('container'),
      flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
      silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
      url: _this.props.token.ALI_HOST,
      auto_start: true,
      log_level: 5,
      filters: {
        mime_types: [{
          title: _this.props.title, //"Image files",
          extensions: _this.props.extensions, //"jpg,png,jpeg"
        },],
        max_file_size: _this.props.max_file_size, //'500mb',
        prevent_duplicates: false, //不允许选取重复文件
      },
      init: {
        PostInit: function () { },
        FilesAdded: function (up, files) {
          // console.log("文件添加队列后，处理相关的事情")
          if (typeof _this.props.filesAdded == 'function') {
            if (_this.props.filesAdded(up, files)) {
              _this.set_upload_param(_this.uploader, '', false)
            }
          } else {
            _this.set_upload_param(_this.uploader, '', false)
          }
        },
        BeforeUpload: function (up, file) {
          _this.set_upload_param(up, file.name, true)
        },

        UploadProgress: function (up, file) {
          _this.props.uploadProgress(up, file)
        },

        FileUploaded: function (up, file, info) {
          let uploaded_object_name = _this.get_uploaded_object_name(file.name)
          _this.props.fileUploaded(up, file, info, uploaded_object_name)
        },

        Error: function (up, err) {
          let console = document.getElementById('console')
          console &&
            console.appendChild(
              document.createTextNode('\nError xml:' + err.response)
            )
        },
      },
    })
    this.uploader.init()
    return {
      host: this.props.token.ALI_HOST,
      OSSAccessKeyId: 'LTAIJmo2WmVgQdpV',
      policy: this.policyBase64,
      success_action_status: '200', //让服务端返回200,不然，默认会返回204
      signature: this.signature,
    }
  }

  random_string = (len) => {
    len = len || 32
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    let maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  }

  get_suffix = (filename) => {
    let pos = filename.lastIndexOf('.')
    let suffix = ''
    if (pos != -1) {
      suffix = filename.substring(pos)
    }
    return suffix
  }

  calculate_object_name = (filename) => {
    let suffix = this.get_suffix(filename)
    this.g_object_name = this.g_dirname + this.random_string(10) + suffix

    return ''
  }

  get_uploaded_object_name = (filename) => {
    return this.g_object_name
  }

  set_upload_param = (up, filename, ret) => {
    this.g_object_name = this.g_dirname
    if (filename != '') {
      let suffix = this.get_suffix(filename)
      this.calculate_object_name(filename)
    }
    let new_multipart_params = {
      key: this.g_object_name,
      policy: this.policyBase64,
      OSSAccessKeyId: 'LTAIJmo2WmVgQdpV',
      success_action_status: '200', //让服务端返回200,不然，默认会返回204
      signature: this.signature,
    }

    up.setOption({
      url: this.props.token.ALI_HOST,
      multipart_params: new_multipart_params,
    })

    up.start()
  }

  render() {
    this.props.uploaderInit(this.uploaderInit)
    return <React.Fragment />
  }
}

export default Index